import { ComponentProps } from '@components/strapi/DynamicZoneComponent';
import { AppointmentFormSectionDTO } from '@lib/strapi/dtos/components/sections/appointmentFormSection.dto';
import AppointmentForm from '@components/appointment-form';
import useTranslation from 'next-translate/useTranslation';

const AppointmentFormSectionImplementation = ({ section }: ComponentProps<AppointmentFormSectionDTO>) => {
  const { t } = useTranslation('main');
  return (
  <section className="my-8 max-w-xl">
    <AppointmentForm
      appointmentHeading={section?.heading ?? t('booking.defaultHeading')}
      appointmentPrompt={t('booking.sectionPrompt')}
      view="boxed"
      placement="section"
    />
  </section>
  );
};

export default AppointmentFormSectionImplementation;
